(function () {

    'use strict';

    var CategoryFilterCmp = {
        controller: CategoryFilterCmpCtrl,
        bindings:{
            onRemoveFilter: '&',
            setFilter: '<',
            deleteFilters: '<'
        },
        templateUrl: 'category-filter.component.html'
    };

    angular.module( 'itxApp.catalog')
        .component('categoryFilter', CategoryFilterCmp);

    CategoryFilterCmpCtrl.$inject = ['ItxFiltersManagerSvc'];

    function CategoryFilterCmpCtrl(ItxFiltersManagerSvc) {
        var _this = this;

        _this.types = [];
        _this.qualities = [];
        _this.characteristics = [];
        _this.colors = [];
        _this.sizes = [];

        _this.ItxFiltersManagerSvc = ItxFiltersManagerSvc;

        _this.$onChanges = function (c) {
            if ( c.setFilter && c.setFilter.currentValue != c.setFilter.previousValue ) {
                _this.getFilters();
            }
            if ( c.deleteFilters && c.deleteFilters.currentValue != c.deleteFilters.previousValue ) {
                _this.resetFilters();
            }
        };

        _this.showPriceFilter = function () {
            var prices = _this.ItxFiltersManagerSvc.getFilters().prices;
            if (prices) {
                if (Object.keys(prices).length === 2) {
                    return true;
                } else {
                    if ((prices.minStep !== undefined && (prices.min !== prices.minStep)) ||
                        (prices.maxStep !== undefined && (prices.max !== prices.maxStep))) {
                        return true;
                    }
                }
            }
            return false;
        };

        _this.removeFilter= function(filter, types){
            filter.typeFilter = types;
            _this.onRemoveFilter({filter:filter});
            //_this.getFilters();
        };

        _this.getFilters = function () {
            _this.types = ItxFiltersManagerSvc.getSelectedFilters('types');
            _this.qualities = ItxFiltersManagerSvc.getSelectedFilters('qualities');
            _this.characteristics = ItxFiltersManagerSvc.getSelectedFilters('characteristics');
            _this.colors = ItxFiltersManagerSvc.getSelectedFilters('colors');
            _this.sizes = ItxFiltersManagerSvc.getSelectedFilters('sizes');
            _this.sizesCategory = ItxFiltersManagerSvc.getCategoryPathFilter();
            if (_this.sizesCategory.length > 0) {
                _this.sizes = ItxFiltersManagerSvc.removeVisibleFiltersByCategoryPath(_this.sizes);
            }
            _this.totalProducts = ItxFiltersManagerSvc.getProductCount();
        };

        _this.resetFilters = function () {
            _this.types = [];
            _this.qualities = [];
            _this.characteristics = [];
            _this.colors = [];
            _this.sizes = [];
        }

    }

})();
